<!-- eslint-disable vue/multi-word-component-names -->
<!-- eslint-disable vue/no-reserved-keys -->
<script>
import axios from "axios";
import i18n from "@/plugins/i18n";
import PDFViewer from "./pdfViewer.vue";
export default {
  name: "ProjectSearchEngine",
  components: {
    PDFViewer,
  },
  data() {
    return {
      searchModal: true,
      searchString: "",
      searchCount: 250, /* can change */
      loadingSearchTable: false,
      searchs: [],
      _searchs: [],
      compaines: [],
      loadingCompanies: false,
      fields: [
        {
          key: "participant_name",
          label: i18n.t("projectSearchEngine.header.participant_name"),
        },
        {
          key: "ownership",
          label: i18n.t("projectSearchEngine.header.ownership"),
        },
        {
          key: "org_type",
          label: i18n.t("projectSearchEngine.header.org_type"),
        },
        {
          key: "sector",
          label: i18n.t("projectSearchEngine.header.sector"),
        },
        {
          key: "country",
          label: i18n.t("projectSearchEngine.header.country"),
        },
        {
          key: "sub_region",
          label: i18n.t("projectSearchEngine.header.sub_region"),
        },
        {
          key: "region",
          label: i18n.t("projectSearchEngine.header.region"),
        },
        {
          key: "file_language",
          label: i18n.t("projectSearchEngine.header.file_language"),
        },
        {
          key: "published",
          label: i18n.t("projectSearchEngine.header.published"),
        },
        {
          key: "file_url",
          label: i18n.t("projectSearchEngine.header.file_url"),
        },
      ],
      openUpdateModal: false,
      searchedString: "",
      searchedCount: 10,
      pdfModal: false,
      reportNameModal: "",
      pdfItem: "",

      ascending: true,
      base: "",

      // for filtering options //
      
      countries: [],
      regions: [ //???????????????????????????//
        'Africa',
        'Americas',
        'Asia',
        'Europe',
        'Oceania'
      ],
      subRegions: [ //???????????????????????????//
        'Northern Africa',
        'Sub-Saharan Africa',
        'Latin America and the Caribbean',
        'Northern America',
        'Central Asia',
        'Eastern Asia',
        'South-eastern Asia',
        'Southern Asia',
        'Western Asia',
        'Eastern Europe',
        'Northern Europe',
        'Southern Europe',
        'Western Europe',
        'Australia and New Zealand',
        'Melanesia',
        'Micronesia',
        'Polynesia'
      ],
      sectors: [],
      languages: [ //??????????????????????????? what am i even doing//
        'Turkish',
        'English',
        'German',
        'Spanish',
        'Italian',
        'Portuguese',
        'Japanese',
        'Korean',
        'Arabic',
        'Russian',
        'Ukranian',
        'Serbian',
        'Hindi',
        'French',
        'Chinese',
        'Greek',
        'Croatian',
        'Polish',
        'Lithuanian',
        'Latvian',
        'Estonian',
        'Czech',
        'Icelandic'
      ],

      filterModal: false,

      filters: {
        sector: "",
        country: "",
        region: "",
        sub_region: "",
        file_language: ""
      }
    };
  },
  computed: {
    disabledControl() {
      const searchNumber = parseInt(this.searchCount, 10);
      return (
        this.searchString &&
        !isNaN(searchNumber) &&
        Number.isInteger(searchNumber)
      );
    },
  },
  mounted() {
    this.$toast.open({
      message: i18n.t("projectSearchEngine.toastTitle"),
      type: "info",
      duration: 5000,
      dismissible: true,
    });

    this.getCountries();
    this.getSectors();
  },
  methods: {
    searchRequest() {
      this.searchs = [];
      this.searchModal = false;
      this.loadingSearchTable = true;
      this.searchedString = this.searchString;
      this.searchedCount = this.searchCount;
      let params = {
        q: this.searchString,
        size: this.searchCount,
      };
      for (const key in this.filters) {
        if (Object.hasOwnProperty.call(this.filters, key)) {
          const element = this.filters[key];
          
          params[key] = element;
        }
      }

      axios.post(`https://ps.sustainfinity.com/api/search/getprojectsearch`, params, {withCredentials: false})
        .then((res) => {
          this.searchModal = false;
          const data = res.data.results.results.best_matches;

          for (let index = 0; index < data.length; index++) {
            const element = data[index];
            this.searchs.push(element);
          }

          const deepCopy = this.searchs;
          this._searchs = deepCopy;
        })
        .catch(({ response }) => {
          this.searchModal = true;
          this.$toast.open({
            message: response.data.message,
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        })
        .finally(() => {
          this.loadingSearchTable = false;
        });
    },
    openPdfModal(data) {
      this.pdfModal = true;
      this.reportNameModal = data.participant_name;
      this.pdfItem = data.file_url;
    },


    sortProjectsAlphabetically(_input, _base) {
      if(_base != this.base) {
        this.ascending = true;
      } else {
        this.ascending = !this.ascending;
      }
      
      this.searchs = this.$sortAlphabetically(_input, _base, this.ascending);
      this.base = _base;
    },
    sortProjectsByDate(_input, _base) {
      if(_base != this.base) {
        this.ascending = true;
      } else {
        this.ascending = !this.ascending;
      }
      
      this.searchs = this.$sortDates(_input, _base, this.ascending);
      this.base = _base;
    },

    ascendingCheck(base){
      return !this.ascending && (this.base == base) 
    },
    descendingCheck(base){
      return this.ascending && (this.base == base) 
    },

    // FILTERING //


    getCountries() {
      axios.get(`https://countriesnow.space/api/v0.1/countries/positions`, { withCredentials: false }).then( res => {
        const data = res.data.data;

        data.forEach( item => {
          this.countries.push( item.name )
        })
      })
    },
    getSectors() {
      axios.post('https://api.innoem.com/api/sector/getsectors', {'is_deleted': false}, { withCredentials: false }).then( res => {
        const data = res.data;

        data.forEach( item => {
          this.sectors.push( item.sust_sector_name );
        })
      })
    },

    openFilterModal() {
      this.filterModal = true;
    },
    resetFilters() {
      this.filters = {
        "sector": "",
        "country": "",
        "region": "",
        "sub_region": "",
        "file_language": ""
      }
    },
    resetFilter(key) {
      this.filters[key] = "";
    }
  },
};
</script>

<template>
  <div class="p-3">

    <div id="sust-banner">
      <a href="https://www.sustainfinity.com/">
        <img src="../assets/sustainfinity.png" alt="Logo" id="sust-logo">
      </a>

      <div id="banner-header">
        Project Search Engine
      </div>
    </div>


    <div class="row justify-content-between pt-4">
      <div class="col-5 searchbar ml-5">
        <input type="text" id="project-search" class="col-8" 
          placeholder="Search" v-model="searchString" v-on:keyup.enter="searchRequest"
        >
        <b-icon icon="search" class="col-1 search-icon" @click="searchRequest" />
      </div>
      <div class="filter-button" @click="openFilterModal">
        {{ $t('projectSearchEngine.filterModule.filter')}}
      </div>
    </div>

    <div class="col-12 mt-3 mx-auto surveys-info-container">
      <div class="row col-12 mx-auto text-center surveys-top-tab">
        <div class="header--sortable p-3 text-center border-right border-solid col-2 "
          @click="sortProjectsAlphabetically(searchs, 'participant_name', ascending)"
        >
          {{$t("projectSearchEngine.header.participant_name")}}
          <i class="fa-solid fa-chevron-down sort-indicator" v-if="ascendingCheck('participant_name')"></i>
          <i class="fa-solid fa-chevron-up sort-indicator" v-if="descendingCheck('participant_name')"></i>
        </div>
        <div class="header--sortable p-3 text-center border-right border-solid col-2 "
          @click="sortProjectsAlphabetically(searchs, 'ownership', ascending)"
        >
          {{$t("projectSearchEngine.header.ownership")}}
          <i class="fa-solid fa-chevron-down sort-indicator" v-if="ascendingCheck('ownership')"></i>
          <i class="fa-solid fa-chevron-up sort-indicator" v-if="descendingCheck('ownership')"></i>
        </div>
        <div class="header--sortable p-3 text-center border-right border-solid col-1 "
          @click="sortProjectsAlphabetically(searchs, 'org_type', ascending)"
        >
          <span v-b-tooltip="{variant: 'default', title:($t('projectSearchEngine.header.org_type_T'))}">
            {{$t("projectSearchEngine.header.org_type")}}
          </span>
          <i class="fa-solid fa-chevron-down sort-indicator" v-if="ascendingCheck('org_type')"></i>
          <i class="fa-solid fa-chevron-up sort-indicator" v-if="descendingCheck('org_type')"></i>
        </div>
        <div class="header--sortable p-3 text-center border-right border-solid col-1 "
          @click="sortProjectsAlphabetically(searchs, 'sector', ascending)"
        >
          {{$t("projectSearchEngine.header.sector")}}
          <i class="fa-solid fa-chevron-down sort-indicator" v-if="ascendingCheck('sector')"></i>
          <i class="fa-solid fa-chevron-up sort-indicator" v-if="descendingCheck('sector')"></i>
        </div>
        <div class="header--sortable p-3 text-center border-right border-solid col-1 "
          @click="sortProjectsAlphabetically(searchs, 'country', ascending)"
        >
          {{$t('projectSearchEngine.header.country')}}
          <i class="fa-solid fa-chevron-down sort-indicator" v-if="ascendingCheck('country')"></i>
          <i class="fa-solid fa-chevron-up sort-indicator" v-if="descendingCheck('country')"></i>
        </div>
        <div class="header--sortable p-3 text-center border-right border-solid col-1 "
          @click="sortProjectsAlphabetically(searchs, 'sub_region', ascending)"
        >
          {{$t('projectSearchEngine.header.sub_region')}}
          <i class="fa-solid fa-chevron-down sort-indicator" v-if="ascendingCheck('sub_region')"></i>
          <i class="fa-solid fa-chevron-up sort-indicator" v-if="descendingCheck('sub_region')"></i>
        </div>
        <div class="header--sortable p-3 text-center border-right border-solid col-1 "
          @click="sortProjectsAlphabetically(searchs, 'region', ascending)"
        >
          {{$t('projectSearchEngine.header.region')}}
          <i class="fa-solid fa-chevron-down sort-indicator" v-if="ascendingCheck('region')"></i>
          <i class="fa-solid fa-chevron-up sort-indicator" v-if="descendingCheck('region')"></i>
        </div>
        <div class="header--sortable p-3 text-center border-right border-solid col-1 "
          @click="sortProjectsAlphabetically(searchs, 'file_language', ascending)"
        >
          <span v-b-tooltip="{variant: 'default', title:($t('projectSearchEngine.header.file_language_T'))}">
            {{$t('projectSearchEngine.header.file_language')}}
          </span>
          <i class="fa-solid fa-chevron-down sort-indicator" v-if="ascendingCheck('file_language')"></i>
          <i class="fa-solid fa-chevron-up sort-indicator" v-if="descendingCheck('file_language')"></i>
        </div>
        <div class="header--sortable p-3 text-center border-right border-solid col-1"
          @click="sortProjectsByDate(searchs, 'published', ascending)"
        >
          {{$t('projectSearchEngine.header.published')}}
          <i class="fa-solid fa-chevron-down sort-indicator" v-if="ascendingCheck('published')"></i>
          <i class="fa-solid fa-chevron-up sort-indicator" v-if="descendingCheck('published')"></i>
        </div>
        <div class="p-3 text-center col-1  ">
          {{$t('projectSearchEngine.header.file_url')}}
        </div>
      </div>

      <div v-if="searchs.length>0" class="text-center col-12 mx-auto surveys-info-tab shadow">
        <div class="row text-center surveys shadow pt-2 pb-2" v-for="(res, index) in searchs" :key="index">
            <div class="p-1 text-center col-2">{{ res.participant_name }}</div>
            <div class="p-1 text-center col-2">{{ res.ownership }}</div>
            <div class="p-1 text-center col-1">{{ res.org_type }}</div>
            <div class="p-1 text-center col-1">{{ res.sector }}</div>
            <div class="p-1 text-center col-1">{{ res.country }}</div>
            <div class="p-1 text-center col-1">{{ res.sub_region }}</div>
            <div class="p-1 text-center col-1">{{ res.region }}</div>
            <div class="p-1 text-center col-1">{{ res.file_language }}</div>
            <div class="p-1 text-center col-1">{{ res.published }}</div>
            <div class="p-1 text-center col-1 d-flex justify-content-center align-content-center mt-1 mx-auto">
              <i class="fa-solid fa-file-pdf" style="font-size: 25px; color: #44a900; cursor: pointer;"
                @click="openPdfModal(res)"
              >
              </i>
            </div>
        </div>
      </div>

      <div v-else>
        <div class="col-12 p-4 text-center surveys" style="border-bottom-left-radius: 30px; border-bottom-right-radius: 30px;">
          <h5>{{ $t("noData.text") }}</h5>
        </div>
      </div>
    </div>

    <br /><br /><br />

    
    <b-modal
      v-model="pdfModal"
      ref="modal"
      :title="reportNameModal"
      centered
      size="xl"
    >
      <b-container class="bv-example-row">
        <b-row class="text-center">
          <b-col cols="12">
            <PDFViewer :pdfUrl="pdfItem" />
          </b-col>
        </b-row>
      </b-container>

      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="danger" @click="cancel()">
          {{ $t("registerForm.buttonTitles.close") }}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="filterModal"
      ref="modal"
      hide-header
      centered
      size="lg"
      @ok="filterModal = false"
      @cancel="resetFilters"
    >
      <div class="row justify-content-center">
        <div class="row col-12 p-3 justify-content-center">
          <div class="position-relative col-6">
            <div class="row">
              {{ $t('projectSearchEngine.header.sector')}}
            </div>
            <b-form-select
              class="row"
              :options="sectors"
              v-model="filters.sector"
            />
            <i class="fa-solid fa-x position-absolute --x-icon" @click="resetFilter('sector')"></i>
          </div>
          <div class="position-relative col-6">
            <div class="row">
              {{ $t('projectSearchEngine.header.file_language_T')}}
            </div>
            <b-form-select
              class="row"
              :options="languages"
              v-model="filters.file_language"
            />
            <i class="fa-solid fa-x position-absolute --x-icon" @click="resetFilter('file_language')"></i>
          </div>
        </div>

        <div class="row col-12 p-3 justify-content-center">
          <div class="position-relative col-6">
            <div class="row">
              {{ $t('projectSearchEngine.header.region')}}
            </div>
            <b-form-select
              class="row"
              :options="regions"
              v-model="filters.region"
            />
            <i class="fa-solid fa-x position-absolute --x-icon" @click="resetFilter('region')"></i>
          </div>
          <div class="position-relative col-6">
            <div class="row">
              {{ $t('projectSearchEngine.header.sub_region')}}
            </div>
            <b-form-select
              class="row"
              :options="subRegions"
              v-model="filters.sub_region"
            />
            <i class="fa-solid fa-x position-absolute --x-icon" @click="resetFilter('sub_region')"></i>
          </div>
        </div>

        <div class="row col-12 p-3 justify-content-center">
          <div class="position-relative col-6">
            <div class="row">
              {{ $t('projectSearchEngine.header.country')}}
            </div>
            <b-form-select
              class="row"
              :options="countries"
              v-model="filters.country"
            />
            <i class="fa-solid fa-x position-absolute --x-icon" @click="resetFilter('country')"></i>
          </div>
        </div>
      </div>

      <template #modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="danger" @click="cancel()">
          {{ $t("projectSearchEngine.filterModule.reset") }}
        </b-button>
        <b-button size="sm" variant="success" @click="ok()">
          {{ $t('projectSearchEngine.filterModule.apply')}}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<style lang="scss">

  .searchbar {
    position: relative;
  }

  #project-search{
    padding: 5px;
    font-size: 16px;
    width: 100%;

    border: thin solid lightgray;
    border-radius: 1em;

    padding-left: 1em;
    padding-right: 2.5em;

    width: 100%;
  }

  .search-icon{
    transition: scale 100ms;

    position: absolute;

    right: 3.5em;
  }

  .search-icon:hover{
    cursor: pointer;
    scale: 1.5;
  }


  .header--sortable {
    display: flex;
    align-items: center;
  }
  .header--sortable:hover {
    cursor: pointer;
    text-decoration: underline;
  }
  .sort-indicator {
    padding-left: .33em;
  }

  /*///// FILTERING //////*/
  .filter-button {
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    text-align: center;

    max-height: 2.5em;

    color: white;

    box-shadow: 0 .2em .5em .05em #023047e4;
    border-radius: .5em;
    margin-right: 4em;
    padding: 1em;
    font-weight: bold;

    background: linear-gradient(to bottom, var(--sustainfinity-blue), var(--sustainfinity-navy));

    cursor: pointer;
    &:hover {
      filter: hue-rotate(10deg) brightness(105%);
    }
  }

  .--x-icon {
    color: rgb(174, 0, 0);
    right: .8em;
    top: 44%;
    transform: translateY(50%);
    cursor: pointer;
    &:hover {
      filter: brightness(200%);
    }
  }


  .surveys-info-container{
  filter: drop-shadow(0 0 10px gray);
}


table.text-center * {
  text-align: center;
}

.created-rounded{
  border: thin solid #023047;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}
.deleted-rounded{
  border: thin solid #023047;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}
.surveys-add{
  font-size: 10px !important;
  color: white;
  background-color: #44a900 !important;
}
.surveys-deleted{
  font-size: 10px !important;
  color: white;
  background-color: #c70e0e !important;
}
.surveys-active{
  font-size: 10px !important;
  color: white;
  background-color: #023047 !important;
}
.surveys-top-tab{
  font-size: 15px;
  color: white;
  background-color: #023047;
  border-top-right-radius: 24px;
  border-top-left-radius: 24px;
}
.surveys-info-tab{
  color: black;
  font-weight: 200;
  font-size: 13px;
  word-wrap: break-word;
}
.surveys{
  background-color: #ffffff;
}
.surveys:hover{
  background-color:#dfdfdf ;
}
.surveys-info-tab:last-of-type > .surveys:last-of-type {
  border-bottom-right-radius: 24px;
  border-bottom-left-radius: 24px;
}

.tab-btn{
  background-color: #023047;
  color: white;
  cursor: pointer;
}
.active{
  background-color: white;
  color: #023047;
  border: 2px solid #023047;
}

input[type="range"] {
  -webkit-appearance: none;
  appearance: none;
  background: transparent;
  cursor: pointer;
}

input[type="range"]::-webkit-slider-runnable-track {
  background: gray;
  height: 0.1rem;
}

input[type="range"]::-moz-range-track {
  background: gray;
  height: 0.1rem;
}

input[type="range"]::-webkit-slider-thumb {
   -webkit-appearance: none; /* Override default look */
   appearance: none;
   margin-top: -12px; /* Centers thumb on the track */
   background-color: #ffffff;
   border: thin solid black;
   border-radius: 50%;
   height: .5rem;
   width: .5rem;
   margin-top: -.2rem;
}


.surveys:last-of-type > .p-2 {
  border-bottom: none !important;
}

#company-select{
  max-width: 12em;
  padding: .33em;
  text-align: center;

  cursor: pointer;

  border: none;
  outline: none;
  border-radius: 1rem;
  
  background: #44a900;
  
  color: white;
  font-weight: bold;
  font-size: .9em;

  filter: drop-shadow(0 0 .4em rgb(101, 101, 101));
}

.participants-info {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
  text-align: center;
}


#sust-banner {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: center;
  align-items: center;

  padding: 0px;
  padding-left: 100px !important;

  > #banner-header {
    color: var(--sustainfinity-navy);

    font-size: 2em;
    font-weight: bold;


    margin-left: 250px;
  }

  border-bottom: thin solid black;
}

#sust-logo {
  max-width: 150px;
}
</style>